import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
  TextField
} from '@material-ui/core'
import alertIcon from 'src/assets/images/alertIcon.svg'
import { useInactivePageContext } from '../hooks/InactivePageLogicContext'

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center'
    // fontFamily: "DIN Regular Alternate",
  },
  dialogTitle: {
    marginTop: '0.5rem',
    marginBottom: '-0.7rem'
  },
  dialogContent: {
    fontSize: '14px'
  },
  dialogButton: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '0.5rem'
  },
  dialogButtonText: {
    borderRadius: '25px',
    textTransform: 'capitalize',
    height: '40px',
    maxWidth: '145px',
    width: '100%'
  },
  paperClassName: {
    borderRadius: '20px',
    minHeight: '150px',
    minWidth: '40%',
    display: 'flex',
    justifyContent: 'center'
  }
}))

const EmailDialog = (props) => {
  const [step, setStep] = useState(1)
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const classes = useStyles()

  const stepTitle = {
    1: 'Drop your email here to proceed!',
    2: 'Do you want to update your profile email?'
  }

  const {
    setFeedback,
    mutateUpdateProfile,
    isUpdatingProfile,
    updateProfileErrors,
    setOpenEmailDialog,
    refetchUserProfile
  } = useInactivePageContext()

  const handleSave = async () => {
    // Simple email validation
    const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)

    if (!isValidEmail(email)) {
      setEmailError('Please enter a valid email address')
      return
    }
    setEmailError('')
    mutateUpdateProfile(
      { email },
      {
        onSuccess: async (data) => {
          if (data?.statusCode === 200) {
            await refetchUserProfile()
            setFeedback((prev) => ({
              ...prev,
              customerEmail: email
            }))
            setOpenEmailDialog(false)
          } else {
            setEmailError(
              data?.data?.userUpdateProfile?.Message || 'Failed to update email'
            )
          }
        }
      }
    )
  }

  // onConfirm needed for Pop Up in ongoingOrderDetails page
  const { open, setOpen } = props
  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason && reason === 'backdropClick') return
        setOpen(false)
      }}
      aria-labelledby="confirm-dialog"
      className={classes.root}
      PaperProps={{
        className: classes.paperClassName
      }}>
      <DialogTitle>
        <img
          src={alertIcon}
          alt="alert"
          style={{ width: '50px', height: '50px', marginBottom: '10px' }}
        />
        <Typography>{stepTitle[step]}</Typography>
      </DialogTitle>
      <DialogContent
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <TextField
          disabled={step === 2}
          variant="outlined"
          placeholder="example@gmail.com"
          fullWidth
          style={{ width: '100%' }}
          InputProps={{
            style: { height: '40px' }
          }}
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
            setEmailError('')
          }}
        />
        <Typography style={{ marginBottom: '10px' }}>
          {emailError && <span style={{ color: 'red' }}>{emailError}</span>}
          {updateProfileErrors && (
            <span style={{ color: 'red' }}>{updateProfileErrors}</span>
          )}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogButton}>
        {step === 1 ? (
          <Button
            variant="contained"
            onClick={() => {
              // Simple email validation
              const isValidEmail = (val) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)
              if (!isValidEmail(email)) {
                setEmailError('Please enter a valid email address')
                return
              }
              setEmailError('')
              setStep(2)
            }}
            color="primary"
            className={classes.dialogButtonText}>
            Confirm
          </Button>
        ) : (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-around'
            }}>
            {' '}
            <Button
              disabled={isUpdatingProfile}
              variant="outlined"
              onClick={() => {
                setOpen(false)
                setFeedback((prev) => ({
                  ...prev,
                  customerEmail: email
                }))
              }}
              color="primary"
              className={classes.dialogButtonText}>
              Skip
            </Button>
            <Button
              disabled={isUpdatingProfile}
              variant="contained"
              onClick={() => {
                handleSave()
              }}
              color="primary"
              className={classes.dialogButtonText}>
              Save
            </Button>
          </div>
        )}
      </DialogActions>
    </Dialog>
  )
}
export default EmailDialog
